export default {
  selected: '已选择',
  deselect_all_selected_options: '取消选择所有已选项',
  expanded: '已展开',
  collect: '收集',
  no_options_available: '没有可用选项',
  required: '必填',
  input_clear_aria_label: '清除输入',
  input_show_hide_password_aria_label: '显示或隐藏密码',
  input_increment_aria_label: '增加数值',
  input_decrement_aria_label: '减少数值',
  english: '英语',
  chinese: '中文',
  portuguese: '葡萄牙语',
  spanish: '西班牙语',
  dutch: '荷兰语',
  french: '法语',
  german: '德语',
  russian: '俄语',
  ukrainian: '乌克兰语',
  korean: '韩语',
  italian: '意大利语',
  czech: '捷克语',
  access_your_account: '访问您的账户',
  use_your_company_credentials_to_get_started: '使用您的公司凭证开始',
  this_link_has_expired: '此链接已过期',
  login: '登录',
  sample_no_production_date_message: '必须选择生产日期',
  free_comment: '自定义评语',
  save_comments: '保存 & 关闭',
  round_list_rounds: '品评计划',
  round_edit_round: '编辑品评',
  round_new_round: '新增品评',
  round_remove_round: '是否确定要删除该轮品评',
  round_schedule: '计划',
  round_tasters_unselect_all: '取消全选',
  round_tasters_select_all: '选择所有品评员',
  round_close: '结束品评',
  round_close_message: '您确定要结束这一轮品评吗',
  round_create_site_message: '您正在创建一个不属于您们工厂的品评！',
  round_closed_message: '无法编辑已结束的品评',
  round_status_created: '创建',
  round_status_samples: '样品',
  round_status_scheduled: '已计划',
  round_status_tasters: '品评员',
  round_status_in_progress: '进行中',
  round_status_finished: '已完成',
  round_status_closed: '已关闭',
  round_schedule_start_finish_date: '开始日期不能晚于结束日期！',
  round_schedule_finish_date_no_start_date: '您必须先选择一个开始日期！',
  round_disabled_discussion_tooltip: '您不能给未结束的品评添加评论',
  round_up_down_maintenance_tooltip: '当前功能维护中，暂不可用',
  round_delete_other_users_rounds: '您没有权限去删除不是您创建的品评',
  round_randomize_samples_order_button: '随机',
  round_block_results_tooltip:
    '在报告页中禁止下载这一轮品评的报告。如果该按钮被禁用，则您无权在此位置锁定品评报告',
  round_block_results_confirm: '是否确认要禁止/取消禁止该轮品评报告的下载',
  round_block_results_no_privilege:
    '您无权从此位置禁止/取消禁止该轮品评报告的下载。',
  sample_list_samples: '样品',
  sample_edit_sample: '编辑样品',
  sample_new_sample: '新样品',
  sample_remove_sample: '移除样品',
  sample_upload_document: '上传文件',
  sample_download_documents: '下载文件',
  sample_tasted_dates: '品评日期',
  sample_upload_message: '要上传多个文档，请将它们添加到',
  sample_not_for_kpi: '不适用于KPI',
  sample_package: '包装',
  sample_volume: '容量',
  sample_production_date: '生产日期',
  'sample_no_production_date_message ': '生产日期为必填项',
  sample_expire_date: '过期时间',
  sample_trial_identifier: '测试识别码',
  sample_project_name: '项目名称',
  sample_linked: '链接到新一轮',
  sample_expire_bigger_than_production: '生产日期不能晚于过期时间！',
  sample_no_site_message: '必须选择区域、国家和工厂来创建样品。',
  sample_no_brand_message: '必须选择一个品牌。',
  sample_duplicated_kpi_message:
    '您选择的月份、品牌和工厂已经有KPI，您将无法保存',
  sample_duplicated_kpi_message_quarter:
    '您选择的季度、品牌和工厂已经有KPI，您将无法保存',
  sample_duplicated_project_message:
    '已经有一个带有此项目名称、工厂和品牌的测试识别码的样品，您将无法保存',
  sample_project_no_name_or_trial: '项目名称和测试识别码为必填项',
  sample_production_to_project_confirm_message:
    '您正在将此样品的类型从产品更改为项目，你想继续吗？',
  sample_project_to_production_confirm_message:
    '您正在将此样品的类型从项目更改为产品，你想继续吗？',
  sample_no_volume_message: '创建/编辑样品时，必须注明包装类型和容量。',
  sample_id_code_message: '请附上完整的批号',
  sample_show_all_samples_hint:
    '显示从今天起六个月内创建的样品。如果还想查看更早的样品，请选中此框',
  sample_show_all_samples_label: '展示所有样品',
  package_duplicate: '已经有一个同名的包装类型',
  common_production: '生产',
  common_project: '项目',
  group_list_groups: '品评小组',
  group_edit_group: '编辑品评小组',
  group_new_group: '新增品评小组',
  group_remove_group: ' 删除品评小组',
  group_close_modal: '关闭',
  group_duplicated_user: '此用户已被添加到此组！',
  group_no_name_message: '必须输入组名',
  group_no_zone_message: '必须选择一个大区',
  group_no_users_message: '必须至少选择一名品评员',
  family_list_families: '类型',
  family_edit_family: '编辑类型',
  family_new_family: '新类型',
  family_remove_family: '删除类型',
  families_page_description: '集中管理所有类型及其配置',
  family_new_page_description: '填写类型信息并完成创建。',
  family_edit_page_description: '编辑类型信息。',
  family_save_success: '类型创建成功！',
  family_update_success: '类型更新成功！',
  family_save_failed: '类型保存失败。',
  family_save_success_desc: '请在下方类型中查看。',
  family_update_success_desc: '请在下方类型中查看。',
  family_save_failed_desc: '请稍后重试。',
  the_name_is_duplicated: '该名称已存在。',
  common_style_name: '类型名称',
  common_warning: '警告',
  enter_language: '输入{{language}}',
  cancel_new_family_title: '取消新建类型？',
  cancel_edit_family_title: '取消编辑类型？',
  cancel_new_family_confirm: '取消新建类型',
  cancel_edit_family_confirm: '取消编辑类型',
  family_remove_success: '类型删除成功',
  family_remove_failed: '删除类型失败',
  family_delete_title: '删除类型？',
  family_delete_description: '{{name}} 类型将被永久删除。确定要继续吗？',
  family_delete_success: '类型删除成功！',
  family_delete_success_desc: '该类型已被移除。',
  family_delete_failed: '类型删除失败。',
  family_delete_failed_desc: '请稍后重试。',
  family_has_no_english_name: '注意：类型名称必须是英文的',
  brand_list_brands: '常规品牌',
  brand_edit_brand: '编辑常规品牌',
  brand_new_brand: '新增常规品牌',
  brand_remove_brand: '删除常规品牌',
  brand_profile_picture: '上传风味图谱',
  brand_upload_brand_logo: '上传品牌标识',
  brand_duplicate: '警告：已有一种啤酒使用这个名字',
  brand_has_no_english_name: '您必须填写一个品牌名称和与之对应的风味图谱',
  brand_upload_help_message: '仅限PNG和JPG文件',
  brand_has_no_product_type: '您必须选择一种产品类型',
  package_list_packages: '包装',
  package_edit_package: '编辑包装',
  package_new_package: '新包装',
  package_remove_package: '删除包装',
  package_has_no_english_name: '注意：包装名称必须为英文',
  package_volumes: '容量',
  package_new_volume: '新的容量',
  package_remove_volume: '删除容量',
  degree_list_degrees: '程度',
  degree_edit_degree: '编辑程度',
  degree_new_degree: '新增程度',
  degree_remove_degree: '去除程度',
  category_list_categories: '类别',
  category_edit_category: '编辑风味类别',
  category_new_category: '新风味类别',
  category_remove_category: '删除风味类别',
  comment_list_comments: '风味物质属性',
  comment_edit_comment: '编辑风味物质属性',
  comment_new_comment: '新风味物质属性',
  comment_remove_comment: '移除风味评语属性',
  comment_cancel_new_title: '取消新建风味评语属性？',
  comment_cancel_edit_title: '取消编辑风味评语属性？',
  comment_cancel_new_confirm: '取消新建风味评语属性',
  comment_cancel_edit_confirm: '取消编辑风味评语属性',
  comment_successfully_created: '风味评语属性创建成功！',
  comment_successfully_created_desc: '可在下方属性列表中查看。',
  comment_successfully_updated: '风味评语属性更新成功！',
  comment_successfully_updated_desc: '可在下方属性列表中查看。',
  comment_create_failed: '风味评语属性创建失败。',
  comment_update_failed: '风味评语属性更新失败。',
  comment_failed_desc: '请稍后重试。',
  comment_delete_title: '删除属性？',
  comment_delete_description: '{{name}} 属性将被永久删除。确定要继续吗？',
  comment_delete_success: '属性删除成功！',
  comment_delete_success_desc: '可在下方属性列表中查看。',
  comment_delete_failed: '属性删除失败。',
  comment_delete_failed_desc: '请稍后重试。',
  user_list_users: '用户',
  user_edit_user: '编辑用户',
  user_new_user: '新增 ABI 承包商用户',
  user_export_users: '导出用户',
  user_list_profiles: '角色',
  user_profile_name: '角色名称',
  user_profile_select: '选择一个文件',
  user_profile_remove: '删除文件',
  user_profile_save: '保存文件',
  user_remove_user: '删除用户',
  user_use_terms: '批准的使用条款',
  report_list_report: '报告',
  report_list_report_description: '导出各种类型的报告。',
  report_global: '全球品牌结果',
  report_tab_tasting: '品评',
  report_tab_kpi: 'KPI',
  report_tab_evaluation: '评估',
  report_tab_site: '工厂',
  report_tab_brand: '品牌',
  report_tab_physchem: '理化',
  report_tab_global: '全球',
  report_start_date: '开始日期',
  report_end_date: '结束日期',
  common_privileges: '权限',
  common_abi_name: 'ABI名称',
  common_id: 'ID',
  common_ranked: '排名',
  common_week: '周',
  common_weeks: '周',
  common_days: '天',
  common_category: '风味类别',
  common_category_sample: '类别',
  common_degree: '程度',
  common_comment: '风味物质属性',
  common_status: '状态',
  common_zone: '大区',
  common_country: '国家',
  common_site: '工厂',
  common_start_date: '计划开始时间',
  common_finish_date: '计划结束时间',
  common_round_type: '品评类型',
  common_type: '类型',
  common_round: '品评计划',
  common_round_id: '品评计划ID',
  common_tasters: '品评员',
  common_taster: '品评员',
  common_sample_performance: '样品信息',
  common_taste: '品评',
  common_key_taster: '关键品评员',
  common_sample: '样品',
  common_samples: '样品',
  common_sample_type: '样品类型',
  common_family: '类型',
  common_brand: '品牌',
  common_product_type: '产品类型',
  common_temperature: '储存条件',
  common_storage_times: '储存时间',
  common_sku: 'SKU',
  common_batch: '批次号',
  common_kpi_month: '关键绩效指标月',
  common_logo: '标识',
  common_name: '名称',
  common_notes: '备注',
  common_email: '电子邮件',
  common_language: '语言',
  common_terms_of_use: '使用条款',
  common_new: '新的',
  common_profile: '权限',
  common_filter: '筛选用户',
  common_download: '下载',
  download: '下载',
  common_save: '保存',
  common_cancel: '取消',
  unsaved_changes_warning: '您有未保存的更改，确定要离开吗？',
  common_go_back: '返回',
  cancel_create_action_title: '取消创建行动？',
  cancel_edit_action_title: '取消编辑行动？',
  cancel_create_action_confirm: '取消创建行动',
  cancel_edit_action_confirm: '取消编辑行动',
  cancel_new_kpi_brand_title: '取消新建 KPI Brand？',
  cancel_edit_kpi_brand_title: '取消编辑 KPI Brand？',
  unsaved_changes_description:
    '您已在表单中输入了内容。取消将丢弃所有未保存的输入。确定要继续吗？',
  unsaved_changes_edit_description:
    '您已在表单中更改了内容。取消将丢弃所有未保存的输入。您确定要继续吗?',
  cancel_new_kpi_brand_confirm: '取消新建 KPI Brand',
  cancel_edit_kpi_brand_confirm: '取消编辑 KPI Brand',
  cancel_add_taster_title: '取消添加品评员？',
  cancel_add_taster_description:
    '您已选择品评员。取消操作将丢弃当前选择，确定要继续吗？',
  cancel_add_taster_confirm: '取消添加品评员',
  cancel_enter_concentration_title: '取消录入浓度？',
  cancel_enter_concentration_description:
    '您已录入酒精浓度值。取消操作将丢弃未保存的输入，确定要继续吗？',
  cancel_enter_concentration_confirm: '取消录入浓度',
  common_search_users: '搜索用户',
  common_search_group: '搜索用户组',
  common_search_taster: '搜索品评员',
  common_no_data: '暂无数据',
  day: '天',
  days: '天',
  common_edit: '编辑',
  common_loading: '加载中...',
  common_search: '搜索...',
  type_more_characters: '请再输入 {{count}} 个字符...',
  common_cannot_be_empty: '{{field}}不能为空',
  common_select_option: '选择选项···',
  search_placeholder: '搜索...',
  no_search_results: '未找到结果',
  clear_selection: '清空选择',
  common_per_page: '每页行数',
  common_attributes: '属性',
  common_not_started: '未开始',
  common_in_progress: '进行中',
  common_finished: '已完成',
  common_start: '开始',
  common_detail: '查看详情',
  common_delete: '删除',
  common_position: '样品顺序',
  common_average_key_score: '关键平均分',
  common_score: '分数',
  common_score_scale: '分数表',
  common_intensity: '程度',
  common_report_not_have_data: '选定的品评没有品评结果',
  month_0: '一月',
  month_1: '二月',
  month_2: '三月',
  month_3: '四月',
  month_4: '五月',
  month_5: '六月',
  month_6: '七月',
  month_7: '八月',
  month_8: '九月',
  month_9: '十月',
  month_10: '十一月',
  month_11: '十二月',
  dropdown_change_picture: '更换照片',
  dropdown_language: '语言',
  dropdown_logout: '注销',
  logout_title: '正在退出，请稍候…',
  logout_description: '您正在退出您的账户。',
  round_not_started: '未开始',
  round_in_progress: '进行中',
  round_finished: '已完成',
  round_filter_start: '开始',
  round_round_type_in_profile: 'In-Profile',
  tasting_list_rounds: '品评计划列表',
  menu_tasting_session: '我的品评',
  menu_panel_management: '品评管理',
  menu_process_management: '过程管理',
  menu_product_management: '产品管理',
  menu_attributes_management: '风味物质属性',
  tasting_finish_sample: '完成品评',
  tasting_comments: '评语',
  tasting_beer_profile: '风味图谱',
  tasting_need_select_score_comments: '您必须添加分数和至少一条评论才能继续',
  tasting_finish_taste: '结束品评',
  tasting_finish_tasting: '结束品评',
  common_no_comments: '没有评论',
  previous_comments: '历史评论',
  review_submit_title: '您确定您准备好提交结果了吗？',
  review_submit_description: '稍后您将无法编辑',
  review_finish_taste: '结束品评',
  review_warning_sample_title: '您有未经品评的样品！',
  review_warning_sample_description: '您确定不品评它们，继续提交吗？',
  review_warning_sample_review: '回顾',
  review_warning_sample_ok: '继续',
  review_warning_preference_description: '请先选择偏好后再继续。',
  review_warning_tie_sample_title: '您有排名相同的样品！',
  review_warning_tie_sample_description: '请重新排名后再结束品评！',
  review_warning_tie_sample_review: '回顾',
  common_submit: '提交',
  common_discussion: '讨论',
  common_not_informed: '没有接到通知',
  discussion_order_number: '按样品顺序排序',
  discussion_order_brewery: '按工厂排序',
  discussion_order_ranking: '按排名排序',
  discussion_order_brand: '按品牌排序',
  discussion_order_score: '按分数排序',
  discussion_order_key_score: '按关键分数排序',
  discussion_order_overall_rank: '按综合排名得分排序',
  discussion_order_key_rank: '按关键排名排序',
  discussion_key_ranking: '关键排名',
  discussion_export_error: '文件无法保存！',
  discussion_ranking: '排名',
  discussion_overall_ranking: '综合排名',
  common_brewery: '工厂',
  common_trial_identifier: '测试ID',
  common_key_score: '关键分数',
  round_report: '导出到Excel',
  common_comments: '评论',
  message_you_cannot_delete_all_comments: '编辑品评结果时不能删除所有评论',
  common_message_empty_profile: '配置文件名称不允许为空',
  common_message_out_score_range: '分数超出范围',
  tasting_need_select_score: '您必须先填写一个分数',
  common_category_name: '类别',
  categories_new_category: '新类别',
  categories_remove_category: '是否确认要删除该类别',
  categories_list_categories: '类别',
  categories_list_all_categories: '所有类别',
  common_category_sample_name: '样品',
  categories_new_category_sample: '新样品',
  categories_remove_category_sample: '您真的想移除该样品吗',
  categories_list_categories_samples: '样品',
  tasting_help: '品评帮助',
  common_back: '返回',
  common_next: '下一页',
  common_sample_id: '样品ID',
  common_sample_date: '样品日期',
  common_duplicate: '复制',
  tasting_raw_materials: '原材料',
  tasting_example_sensory_risk: '主要感官风险示例：不符合预期口味',
  tasting_procedure: '过程',
  tasting_sample_preparation: '样品准备',
  tasting_help_comments: '评语',
  common_collection_point: '收集点',
  common_collection_date: '收集日期',
  common_brew_number: '啤酒编号/MES编号',
  common_need_explain_nok: '您必须为选择NOK的样品添加评语！',
  common_percent_ok: 'OK百分比',
  common_show_all: '全部展示',
  common_import: '导入',
  common_download_template: '下载模板',
  sample_import_message: 'xlsx',
  common_template: '模板',
  common_yes: '是',
  common_no: '否',
  logging_out: '正在退出...',
  common_only_kpi_sample: '仅KPI样品',
  common_need_volte_first: '您不能在没有评分的情况下为样品添加评语！',
  common_name_template: '模板名',
  interaction_log: 'Interaction Log',
  common_message_zone_empty: '大区不允许为空',
  common_message_country_empty: '国家/地区不允许为空',
  common_message_site_empty: '工厂不允许为空',
  user_new_profile_save: '创建了新的配置文档',
  common_in_privileges: '特殊权限',
  common_download_files: '下载文件',
  common_view_details: '查看详情',
  common_create_action: '创建行动',
  common_action_list: '行动列表',
  common_create_action_description: '填写此样本的行动详情。',
  common_optional: '可选',
  action_deadline: '截止日期',
  action_description: '行动描述',
  action_description_autofill_tooltip: '行动描述',
  action_description_autofill_tooltip_description:
    '自动生成（轮次 ID / 工厂 / 样本名称 / 生产日期 / 创建用户）+ 补充描述',
  action_owner: '负责人',
  action_meeting: 'Interaction Log 会议',
  action_meeting_list: 'IAL 会议',
  action_producing_site: '生产工厂',
  action_production_date: '生产日期',
  action_closed_time: '关闭时间',
  action_meeting_placeholder: '请选择会议',
  action_status: '状态',
  action_status_draft: '草稿',
  action_status_not_started: '未开始',
  action_status_in_progress: '进行中',
  action_status_delayed: '延期',
  action_status_close: '关闭',

  action_menu_close: '关闭',
  action_cancel: '取消',
  action_add_comment: '添加评论',
  action_status_canceled: '已取消',
  status_record: '状态记录',
  no_status_record: '暂无状态记录',
  action_type: '行动类型',
  action_create_user: '创建人',
  action_create_time: '创建时间',
  action_creator: '创建者',
  action_root_cause: '根本原因',
  action_description_placeholder: '请输入行动描述...',
  action_root_cause_placeholder: '请输入根本原因...',
  action_comment_added: '评论添加成功',
  action_comment_add_failed: '添加评论失败',
  action_comment_placeholder: '输入您的评论...',
  action_status_changed_with_comment: '状态已变更并附上评论',
  required_comment_banner: '由于您不是此行动的负责人，需要代表负责人提供评论。',
  cancel_and_comment: '取消并评论',
  close_and_comment: '关闭并评论',
  action_edit_action: '编辑行动',
  action_owner_placeholder: '请选择行动负责人',
  action_created_successfully: '行动创建成功！',
  action_created_successfully_desc: '请在行动列表中查看新建的行动。',
  action_updated_successfully: '行动更新成功！',
  action_updated_successfully_desc: '请在行动列表中查看更新的行动。',
  action_create_failed: '创建行动时出现问题',
  action_update_failed: '更新行动时出现问题',
  action_update_failed_desc: '请稍后重试。',
  action_save_failed_desc: '请稍后重试。',
  action_change_status_successfully: '状态已变更！',
  action_change_status_successfully_desc: '行动状态已变更为{{status}}。',
  action_change_status_failed: '状态变更失败',
  action_change_status_failed_desc: '行动状态无法变更，请重试。',
  action_deleted_successfully: '行动删除成功！',
  action_deleted_successfully_desc: '请在行动列表中查看。',
  action_delete_failed: '删除行动时出现问题',
  delete_action_confirm_title: '删除行动？',
  delete_action_confirm_description: '该行动将被永久删除，确定要继续吗？',
  action_added_notification: '[{{userName}}] 新增了行动',
  action_updated_notification: '[{{userName}}] 更新了行动',
  action_deleted_notification: '[{{userName}}] 删除了行动',
  view_action_list: '查看行动列表',
  pdf_viewer: 'PDF预览',
  common_all: '全部',
  common_continue: '继续',
  common_minimum_score: '最小',
  common_maximum_score: '最大',
  common_average_score: '平均',
  file_upload_fail: '未能上传文件，出现了以下错误',
  file_upload_success_with_error: '上传成功，但以下除外：',
  missing_fields: '缺失字段',
  column_error: '列错误',
  common_line: '行',
  file_no_samples: '文档上没有找到样品！',
  file_success_upload: '成功上传文件！',
  file_duplicated_kpi_project: '重复的KPI项目',
  round_schedule_maximum_length: '一轮品评的名称最大长度为40个字符。',
  sample_malt_varieties: '麦芽品种',
  error_sample_already_in_round: '您选择的样品在本轮品评计划中已存在',
  malt_varieties_has_no_english_name: '您必须至少有一个麦芽品种名称。',
  malt_varieties_duplicate: '注意：已经有麦芽品种使用这个名字',
  malt_varieties_remove: '去除种类',
  malt_varieties_new: '新种类',
  malt_varieties_edit: '编辑品种',
  malt_varieties_enter_name: '输入名称',
  malt_varieties_page_description: '在一个地方管理所有麦芽品种及其配置。',
  malt_varieties_save_success: '麦芽品种创建成功！',
  malt_varieties_save_success_desc: '请在下方麦芽品种中查看。',
  malt_varieties_update_success: '麦芽品种更新成功！',
  malt_varieties_update_success_desc: '请在下方麦芽品种中查看。',
  malt_varieties_delete_title: '删除麦芽品种？',
  malt_varieties_delete_description:
    '{{name}} 麦芽品种将被永久删除。确定要继续吗？',
  malt_varieties_delete_success: '麦芽品种删除成功！',
  malt_varieties_delete_success_desc: '请在下方麦芽品种中查看。',
  malt_varieties_delete_failed: '麦芽品种删除失败。',
  malt_varieties_delete_failed_desc: '请稍后重试。',
  cancel_new_malt_variety_title: '取消新建麦芽品种？',
  cancel_edit_malt_variety_title: '取消编辑麦芽品种？',
  cancel_new_malt_variety_confirm: '取消新建麦芽品种',
  cancel_edit_malt_variety_confirm: '取消编辑麦芽品种',
  reports_no_dates: '开始日期和结束日期为必填项！',
  reports_date_range_message: '日期范围不能大于1年',
  round_save_select_site: '要保存一轮，必须选择一个工厂',
  common_error: '出现问题，请再试一次',
  common_horizontal: '橫向布局',
  common_unit: '单位',
  common_supplier: '供应商',
  common_flavor: '风味',
  concentration_of_the_base_beer: '基酒的浓度',
  threshold_aml_method: 'AML方法',
  threshold_component_concentration: '成分浓度',
  threshold_sample_different_help: '哪个样品与其他样品味道不同？',
  threshold_each_set_random_order: '每一组的顺序是随机的',
  threshold_select_base_beer: '选择基酒',
  common_unity: '统一',
  common_finish_session: '完成品评',
  common_filters: '筛选',
  review_submit_threshold: '您确定要保存吗？',
  threshold_coder_wrong: '您的座位号是错误的。请输入正确的座位号！',
  threshold_didnt_enter_the_code: '请输入您的座位号！',
  code: '座位',
  common_batch_code: '批号',
  threshold_samples_required: '需要基酒和风味',
  threshold_information_helper_sample: '请单击“保存”按钮以保留您的更改',
  code_digits: '输入分配给您的 3 位数座位号',
  threshold_sample_spiked_with: '在每组中，选择已加标的样品',
  threshold_code_already_tasted: '此座号已被其他用户用过。输入另一个座号',
  common_kpi_brands: 'KPI品牌',
  common_year: '年',
  common_new_kpi_brand: '新建KPI品牌',
  common_action: '操作',
  kpi_brand_details_title: 'KPI品牌详情',
  kpi_brand_details_description: '查看完整信息和审批流程状态。',
  approval_action: '审批操作',
  select_approval_action: '选择审批操作',
  reject_reason_title: '拒绝原因',
  reject_reason_description: '请提供拒绝原因。',
  reject_reason_label: '拒绝原因',
  reject_reason_placeholder: '请输入拒绝原因...',
  reject_reason_placeholder_site: "请输入拒绝此站点 '{{site}}' 的原因...",
  common_confirm: '确认',
  common_success: '成功',
  common_save_failed: '保存失败，请重试。',
  approval_status_saved_success: '审批状态已成功保存！',
  common_comment_by_category: '按种类的评语',
  common_alphabetic_comment: '按字母表顺序的评语',
  common_name_pts_code: 'PTS码',
  common_name_pts_code_placeholder: '代码',
  common_name_process_item: '过程项',
  common_name_process_item_placeholder: '项',
  common_global_brands: '全球品牌',
  common_global_brand: '全球品牌',
  common_target_global_brand: '全球品牌KPI目标值',
  common_focus_brand: '焦点品牌',
  common_target_focus_brand: '焦点品牌KPI目标值',
  common_strategic_brand: '战略品牌',
  common_target_strategic_brand: '战略品牌KPI目标值',
  common_maximun_sites: '最大对比工厂数为：',
  common_state_reason_rejecting: '请说明不批准此工厂的原因',
  common_rejected_note: '备注',
  report_list_report_kpi: '关键绩效指标报告',
  report_list_report_taste: '品评报告（按方法)',
  report_list_report_evaluation: '评估报告',
  report_list_report_brand: '品牌报告',
  report_list_report_physchem: '理化报告',
  taster_evaluation_report: '品评员评估报告',
  kpi_gbsi_bssi_dispersion: 'GBSI BSSI & Dispersion',
  kpi_freshness: '新鲜度 KPI',
  select_brand_to_filter: '选择全球品牌！',
  select_year_to_filter: '选择年份！',
  kpi_only_numbers_warning: '仅接受目标值上的数字',
  kpi_max_number_range_warning: '您的目标品牌必须介于1到9之间',
  kpi_already_selected_brand_warning: '您已选择此品牌，请选择其他品牌',
  kpi_no_kpi_informed_warning: '您没有任何增值',
  kpi_select_year_warning: '选择年份',
  kpi_select_site_warning: '选择一个工厂',
  kpi_existing_configuration_warning: '您已提交过相同工厂和年份的KPI',
  kpi_target_empty_warning: '您的一个品牌的目标是空的',
  kpi_saved_successfully: '您的值已成功保存!',
  kpi_submitted_successfully: '您的值已提交成功！',
  kpi_max_decimals_warning: '您的目标值不得超过小数点后3位',
  kpi_count_as_kpi_sample: '计入 KPI',
  'samples_uncheck_kpi_sample_tooltip ':
    '如果您不希望此样品计入KPI，请取消选中此框',
  reports_mandatory_zone_filter: '至少选择一个区域',
  common_approve: '批准',
  zone_can_not_empty: '区域不能为空!',
  custom_scale_title: '自定义评分表',
  custom_scale_grid_header_score: '分数范围',
  custom_scale_grid_header_ageind_scale: '老化程度',
  common_approve_reject: '批准/拒绝',
  unique_id: '唯一ID',
  'the_value_cannot_be_null ': '数值不能为空！',
  report_filter_rounds_description: '在搜索品评计划之前，您必须填好必填项',
  reports_mandatory_test_type: '请选择测试类型.',
  round_reports_month_warning: '开始日期和结束日期之间的时间段最长为6个月。',
  submission_type: '提交类型',
  flavor_identification: '风味物质识别',
  flavor_id_discussion: '风味识别讨论',
  view_and_discussion_for: '查看并讨论',
  common_cup: '杯',
  tasters_joined: '已参与品评员',
  tasters_all_correct: '全部正确品评员',
  total_accuracy: '总体准确率',
  accuracy: '准确率',
  all_correct: '全部正确',
  otherwise: '其他',
  result: '结果',
  Key: 'Key',
  nonkey: 'Nonkey',
  common_guest: 'Guest',
  view_correct_answers: '查看正确答案',
  hide_correct_answers: '隐藏正确答案',
  change_to_table: '切换为表格',
  change_to_card: '切换为卡片',
  not_answered: '未作答',
  beer_batch: '批次',
  list_of_beers: '啤酒列表',
  random: '随机',
  preview: '座位预览',
  select_the_flavor: '选择风味',
  flavor_threshold: '风味物质阈值',
  input_digital_number: '请输入整数',
  concentration: '浓度',
  flavor_order: '风味物质顺序',
  last: '上一页',
  tasting: '品评',
  tasting_page_description: '对样品进行品评评估和讨论品评结果。',
  confirmation: '确认',
  do_you_confirm_the_evaluation_of_this_sample: '是否确认提交对此样品的品评？',
  confirm: '确认',
  evaluate: '品评',
  correct_answer: '正确答案',
  threshold: '阈值',
  let_a_comment_about_the_tasting: '给此次品评添加评语',
  send: '发送',
  right_now: '现在',
  minute_ago: '分钟之前',
  hour_ago: '小时之前',
  day_before: '天之前',
  year_ago: '年之前',
  add_a_flavor: '添加一个风味',
  column_options: '配置列',
  configure_table_title: '自定义列',
  configure_table: '配置表格',
  configure_table_description: '选择要显示的列并调整列的排列顺序。',
  configure_table_helper: '至少需要保留 2 个可见列，最多固定 4 个列。',
  configure_table_fixed_left: '左固定',
  configure_table_scroll_area: '滚动区域',
  configure_table_fixed_right: '右固定',
  configure_table_empty_left: '将列拖到这里以固定到左侧',
  configure_table_empty_right: '将列拖到这里以固定到右侧',
  configure_table_save: '保存更改',
  configure_table_reset: '重置为默认值',
  configure_table_discard: '放弃更改',
  configure_table_show: '显示',
  configure_table_hide: '隐藏',
  configure_table_min_visible: '至少需要保留 2 个可见列',
  configure_table_max_fixed: '最多只能固定 4 个列',
  configure_table_drag: '拖拽重新排序',
  configure_table_dragging: '正在拖拽',
  select_which_of_the_columns_do_you_want_to_be_displayed: '选择要显示的列。',
  soft_drinks: '软饮料',
  soft_drinks_brand: '软饮料品牌',
  soft_drinks_brand_target: '软饮料品牌目标',
  countdown: '倒计时',
  less_than_five_minutes: '当前剩余时间不足5分钟,请联系协调员延长结束时间。',
  the_countdown_to_the_evaluation_has_ended: '品评倒计时已结束，无法进入品评。',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    '计算你需要多少时间来品尝完这些样品',
  only_six_flavors_can_be_added_at_most: '至多只能添加六种风味!',
  concentration_of_the_flavor: '风味浓度',
  input_value: '请输入',
  Concentration_of_the_flavor_is_required: '风味浓度不能为空！',
  previous_round: '上一轮',
  next_round: '下一轮',
  the_end_time_is_greater_than_the_current_time:
    '结束时间必须大于当前时间，如果选择的天与当天相同，请先选择小时和分钟!',
  check_the_answer_at_the_end_of_the_countdown:
    '倒计时还未结束，您可在倒计时结束后查看答案',
  incremental_step: '浓度增长系数',
  set3_concentration: 'Set3 浓度',
  concentration_increments_between_levels: '浓度逐级等量递增',
  incremental_set3_concentration_required: '需要浓度增长系数和Set3浓度',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'Sprint 编号必须大于 0',
  sprint_notes_at_least_one_note: '冲刺笔记必须至少有一个笔记',
  sprint_patch_notes_success_update: 'Sprint 补丁说明更新成功.',
  sprint_patch_notes_error_update: '无法保存笔记.',
  sprint_number: '冲刺号码',
  sprint_patch_notes: 'Sprint 补丁说明',
  note: '笔记',
  select_all: '全选',
  please_add_samples_first: '请先添加sample',
  reverse: '翻转',
  score_scale: '分数范围',
  description: '描述',
  aditional_criteria: '额外的标准',
  new_test: '新增测试',
  triangle_test_name: '三角测试名称',
  triangle_test: '三角测试',
  you_can_not_set_three_identical_samples: '不可设置三个相同选项',
  its_mandatory_to_input_test_name: '请填写测试名称',
  its_mandatory_to_input_sample_information: '请填写样品信息',
  attention: '提示',
  test_number: '测试序号',
  you_selected_the: '您选择了',
  next_sample: '下一个样品',
  remove_triangle_test: '删除测试',
  test: '测试',
  confirm_remove: '是否确认删除测试',
  you_can_only_select_up_to_five: '最多允许选择五个',
  reports_mandatory_zone_country_site_filter: '大区,国家,工厂是必填的!',
  reports_mandatory_brand_filter: '至少选择一个品牌',
  reports_by_producing_site: '品评报告（按工厂/品牌)',
  download_label: '下载标签',
  standard: '标准值',
  input_test: '结果录入',
  detecting: '检测中...',
  connected: '已连接',
  current_taster: '当前品评员',
  alcohol_concentration: '酒精浓度',
  alcohol_result_submit_failed_title: '提交结果时出现问题',
  alcohol_result_submit_failed_desc: '请稍后重试。',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    '您的血液酒精浓度超标。请晚些重新进行测试！',
  alcohol_test_qualified: '酒精检测合格',
  alcohol_test_qualified_title: '酒精检测合格！',
  alcohol_test_qualified_desc: '酒精检测结果在可接受范围内。',
  alcohol_test_result_exceeds_standard: '酒精检测结果超出标准',
  alcohol_test_result_exceeds_standard_desc: '请稍后重新检测。',
  alcohol_result_save_failed: '酒精检测结果保存失败。',
  alcohol_concentration_configuration: '酒精浓度配置',
  breathalyzer_configuration_description:
    '配置每个工厂的酒精浓度及用户的驾驶状态。',
  breathalyzer_configuration_save_success_title: '酒精测试仪配置更新成功！',
  breathalyzer_configuration_save_success_description:
    '请在下方设置中查看更新后的配置。',
  breathalyzer_configuration_save_failed_title: '更新酒精测试仪配置时出现问题',
  breathalyzer_configuration_save_failed_description: '请稍后重试。',
  cancel_configuration_title: '取消配置？',
  cancel_configuration_description:
    '您已修改配置。取消操作将丢弃未保存的更改。确定要继续吗？',
  cancel_configuration_confirm: '取消配置',
  driving_configuration: '驾驶配置',
  configuration: '配置',
  input_result: '结果录入',
  maximum_alcohol_concentration: '最大血液酒精浓度',
  breathalyzer: '酒精检测仪',
  breathalyzer_page_description: '在一个地方管理所有酒精检测结果及其配置标准。',
  please_input_a_positive_number_up_to_n_decimal_places:
    '请输入正数且最多{{field}}位小数',
  driving: '是否驾车离厂',
  test_time: '测试时间',
  input_type: '录入方式',
  list_breathalyzer: '酒精检测',
  Manual: '手动输入',
  Breathalyzer: '酒精检测仪',
  you_must_input: '您必须输入',
  you_do_not_have_privilege_to_export_this_report: '您没有权限导出此报告',
  competitor_beer: '竞品',
  split_round: '拆分本轮',
  reset: '重置',
  how_many_rounds_splitting_do_you_want_to_make: '请选择您想拆分的轮数',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    '您不能拆分已经拆分过或进行中的轮次',
  hide_sample_details: '隐藏样品信息',
  hide_sample_details_auto_hide:
    'YES - 您可以拆分样品，并在所有拆分轮次品尝完成后自动显示所有隐藏信息。',
  hide_sample_details_manual_hide:
    'Manual - 不能拆分样品，需要指派临时管理员在讨论页面手动切换解除隐藏或隐藏。',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    '以下信息会对品评员隐藏：工厂，生产日期，品牌，麦芽品种和批次号',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    '此轮选择Manual，拆分功能不可用，您可以选择自动隐藏或不隐藏进行拆分。',
  data_will_be_hidden_for_ok_nok: '全部信息会对品评员隐藏',
  you_can_not_add_duplicate_attributes: '请勿选择重复的风味物质属性',
  menu: '菜单',
  link_breathalyzer: '已连接',
  not_link_breathalyzer: '未连接',
  breathalyzer_to_link: '连接酒精检测仪',
  breathalyzer_connection_failed_title: '酒精检测仪连接失败',
  breathalyzer_connection_failed_desc: '请刷新页面后重试。',
  breathalyzer_can_not_to_link_for_this_browser:
    '请在PC端使用谷歌Chrome浏览器进行酒精检测仪数据读取',
  reopen: 'Reopen',
  round_reopen_message: '您确定要reopen这一轮品评吗',
  common_production_line: '生产线',
  common_packaged_beer_data_code: '喷码',
  common_masking_process_for_bottles: '是否添加美容剂',
  common_str_number_days_over_aged: '超龄天数',
  common_over_aged_beer: '是否超龄酒',
  sample_successfully_swapped: '样品替换成功。',
  scoring: '评分',
  configure_available_flavors: '配置风味物质选项',
  process_check: '在线品评',
  new_process_check: '创建在线品评',
  edit_process_check: '编辑在线品评',
  remove_process_check: '删除在线品评',
  common_package: '包装',
  common_department: '部门',
  common_shift: '班次',
  common_tank: '锅号/罐号',
  common_oknok: 'OKNOK',
  common_remark: '备注',
  show_all_process_check: '展示所有在线品评数据',
  show_all_process_check_help_circle:
    '显示从今天起半年内创建的数据，如果还需查看从今天起一年内创建的数据，请选中此框',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    '取样时间不能大于当前时间!',
  common_job_position: '岗位',
  decimal_sep: '小数分隔符',
  is_swapped_to: '被更换为',
  review_warning_comment_title: '您有未填写评语的样品!',
  continuous_typing: '连续输入',
  continuous_typing_tips: '选择或输入"程度"后持续输入"属性"',
  BSSI_Reports: 'BSSI 报告',
  data_analysis_sip: '数据分析 - SIP',
  select_the_color: '选择一种颜色',
  color: '颜色',
  download_document: '下载文件',
  Month_of_Discontinued_Production: '停产月份',
  Suspension_List: '停产列表',
  New_Suspension: '新停产申请',
  new_suspension_page: '新停产信息',
  edit_suspension_page: '编辑停产信息',
  Brand_name: '品牌名',
  List_Brewery_Production_Suspension: '工厂停产列表',
  Upload_successfully: '文件上传成功',
  training_materials: '培训材料',
  Remove_Suspension: '删除停产信息：',
  Add_Absence_Reason: '添加缺勤原因',
  Reason: '请假原因',
  Select_reason: '选择原因',
  You_have_duplicate_absence_dates: '您有重复的缺勤日期',
  Remove_Absence: '删除缺勤信息：',
  Absence_Title: '请选择品评缺席时间和原因。可在已提交原因中查看或删除记录。',
  Shipping_Site: '收货工厂',
  shipping_received: '到货确认',
  receive_sample_alert: '您确定已经收到样品了吗？',
  receive_uncheck_alert: '您确定要取消勾选吗？',
  all_received: '全部接收',
  not_all_received: '未全部接受',
  not_for_shipping: '无需邮寄',
  receive_hint: '选择将接收该样品的所有工厂',
  absence_reason: '缺席原因',
  Page1: '第 {{field}} 页',
  Search: '搜索',
  page_total: '总数',
  start_date: '开始日期',
  end_date: '结束日期',
  ok_for_all: '一键OK',
  last_days: '近 {{field}} 天',
  today: '今天',
  its_mandatory_to_select_sample_A_and_sample_B: '请选择样品A和样品B',
  its_mandatory_to_select_sample_A: '请选择样品A',
  its_mandatory_to_select_sample_B: '请选择样品B',
  triangle_comment: '备注',
  select_sample: '选择样品',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    '样品日期时间段筛选，默认近7天，且基于所筛选时间段导出品评数据。',
  select_all_flavor: '选择所有风味',
  deselect_all: '取消全选',
  email_distribution: '月报收件人管理',
  new_email_distribution: '新建月报收件人',
  edit_email_distribution: '编辑月报收件人',
  distribution_type: '分发类型',
  the_score_entered_is_invalid:
    '您输入的分数无效。请参考分数表，重新输入您的分数。',
  service_now: '点击创建一个ServiceNow Ticket，来报告问题并获取帮助',
  service_now_tips:
    '如果您在系统的使用过程中遇到任何问题或希望得到帮助，您可以点击这里到ServiceNow中发送报告，我们的支持团队将尽快与您取得联系。',
  done: '完成',
  changes_you_made_may_not_be_saved:
    '您所做的更改可能无法保存。是否要继续并丢失更改？',
  cannel_auto_save_tips:
    '品评页面的性能已进行提升，请不要忘记点击完成品评来保存和提交您的品评结果。',
  list_email_page_tips:
    '了解如何设置KPI样品以在大区月度报告里展示对应数据统计。',
  list_email_page_helps:
    '请点击查看创建MCS品评计划的引导，以便获得正确的大区MCS月报数据。',
  kpi_instruction: 'KPI流程介绍',
  group_no_recipients_message: '至少需要添加一个收件人',
  the_current_distribution_type_already_exists:
    '当前类型已存在，请重新选择邮件类型或返回列表。',
  distribution_type_message_empty: '分发类型不允许为空',
  add_samples: '添加样品轮次中',
  copy_this_sample: '复制样品',
  remove_this_sample: '删除样品',
  drag_samples_here: '拖拽样品到此处',
  drop_here: '放置到此处',
  multiple_selection_tips:
    '您可以为同一样品类型同时选择多个样品。点击"+"和"-"进行尝试。',
  all_add_once_tips: "单击'全选'按钮，为每个选定的样品类型自动添加1个样品",
  copy_confirm_tip: '是否确定要复制该样品？',
  user_non_abi_user: '新增临时用户',
  language_of_email_invitation: '邮件邀请语言',
  add_non_abi_users_to_round:
    '临时品评员会收到一封内附链接的邮件邀请，通过点击链接参与对应品评计划',
  change_non_abi_users_to_round:
    '此处邀请的临时用户会收到一封内附链接的邮件，通过点击链接参与此品评计划。',
  guest: '来访人员',
  email_to_all: '发送邀请邮件',
  send_email: '发送邀请邮件',
  temporary_non_abi_taster: '临时品评员',
  user_type: '用户类型',
  email_invitation_delivery_request_sent: '计划邀请邮件已发送！',
  incorrect_e_mail_formatting: '电子邮件格式不正确',
  all_tasters: '全部品评员',
  tasters: '品评员',
  key_tasters: '关键品评员',
  non_key_tasters: '非关键品评员',
  taster_already_started_cannot_change: '品评员已开始品评，无法更改',
  temporary: '临时用户',
  maximum_number_of_samples_is: '最大样品数为',
  sample_added: '已添加样品',
  click_to_view_scale_of_flavour_intensities: '点击链接查看风味程度表',
  list_next_week_plan: '下周品评计划',
  common_time_zone: '时区',
  common_last_response_time: '最后响应时间',
  new_week_plan: '新建周品评计划',
  invited_week: '受邀周',
  email_language: '邮件语言',
  save_and_send_email: '保存并发送邮件',
  common_start_time: '开始时间',
  common_end_time: '结束时间',
  session_name_email_subject: 'Session名称/邮件主题',
  location: '地点',
  calendar_confirm: '日历确认',
  edit_week_plan: '编辑周品评计划',
  round_remove_plan: '是否确定要删除该计划',
  email_response: '邮件响应',
  are_you_confirming_to_send_the_invitation_email: '您是否确认发送邀请邮件',
  view_week_plan: '查看周品评计划',
  are_you_confirming_to_send_the_confirmation_email: '您是否要发送确认邮件',
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation:
    '每十分钟系统会更新用户针对邮件邀请的反馈',
  documents_upload_tips: '文件上传仅支持 {{field}}',
  ignore_submit: '忽略&提交',
  if_count_as_kpi:
    '检测到以下样品未选择“计入KPI”，如样品需要计算BSSI请进行勾选',
  confirmed_count: '已确认次数',
  accepted: '已接受',
  declined: '已拒绝',
  no_response: '未响应',
  apply_to_all_sessions: '应用于所有Session',
  reminder_time: '提醒时间',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    '请确认您是否想要移除已选择的Session开始/结束时间并选择另一个受邀周',
  apply_to_all_sessions_location_tasters:
    '复制“地点”和“品评员”至下方所有Session中',
  mcs_tasting: '月度寄样酒KPI品评',
  qcs_tasting: '季度寄样酒KPI品评',
  mcs_tasting_tips:
    '如果本轮包含 MCS/KPI 样品请选择Yes，系统将根据样品品牌应用相关 KPI 代码。',
  round_samples_shuffle_confirm: '请确认是否要随机下方所有的Sets?',
  all_count_as_kpi: '全部计入KPI',
  msc_tasting_tour_mask:
    '选择“Yes”后系统将自动识别样品的KPI Code，无需再拆分不同品牌的样品至不同的轮次',
  competition: '竞赛',
  copy_link: '复制链接',
  open_link: '打开链接',
  common_download_img: '下载图片',
  please_select_taster: '请选择您的名字',
  qr_code: '二维码',
  user_principal_name: '用户主要名称',
  user_status: '用户状态',
  termination_date: '离职日期',
  function_level: '职能',
  last_update_time: '最新更新时间',
  system_related: '系统相关',
  workday_related: 'WorkDay 相关',
  employee_id: '员工 ID',
  zitec_project_name: '项目名称',
  applicant: '申请人',
  applicant_date: '申请日期',
  test_method: '测试方法',
  liquid_category: '液体类别',
  conditions: '条件',
  time_points: '时间点',
  execution_date: '执行日期',
  execution_by_time_points: '根据时间点计算执行日期',
  invitation_start_time: '邀请开始时间',
  invitation_end_time: '邀请结束时间',
  invitation_reminder: '邀请提醒',
  application_form: '申请表',
  application_form_result: '品评报告',
  upload_result: '上传结果',
  zitec_sessions: 'ZITEC 计划',
  zitec_id: 'ZITEC ID',
  new_zitec_session: '新增 ZITEC 计划',
  common_search_applicant: '搜索申请人',
  history_record: '历史记录',
  auto: '自动',
  common_quarterly: '季度',
  common_month: '月份',
  kpi_report: 'KPI 报告',
  kpi_result: 'Anaplan 文件',
  action_log: '操作日志',
  validate_data: '验证数据',
  push_anaplan_window_open_date: '推送 Anaplan 窗口开放日期:',
  unLock_kpi: '解锁 KPI',
  lock_kpi: '锁定 KPI',
  locked: '已锁定',
  unlocked: '已解锁',
  menu_kpi_lock: 'KPI 锁定',
  freshness_kpi_lock: '新鲜度锁定',
  in_profile_kpi_lock: 'In Profile 锁定',
  are_you_sure_you_want_to_lock_kpi: '你确定要锁定{{field}}的KPI吗',
  are_you_sure_you_want_to_unlock_kpi: '你确定要解锁{{field}}的KPI吗',
  lock_kpi_month_zone:
    '由于对KPI月份和大区的KPI样品的锁定，您的操作受到限制。如果您有任何疑问，请联系您的大区所有者，了解有关KPI数据锁定的更多详细信息。',
  lock_freshness_kpi_month_zone:
    '由于对KPI季度和大区的KPI样品的锁定，您的操作受到限制。如果您有任何疑问，请联系您的大区所有者，了解有关KPI数据锁定的更多详细信息。',
  submit_timeout: '提交失败，请稍后重试！',
  anaplan_un_upload_tips: '请等待下个窗口开放日期',
  anaplan_un_confirm_tips: '请确认给定月份的KPI数据!',
  confirmed: '已确认',
  confirm_data: '确认数据',
  flavor_groups: `风味物质分组`,
  compound: '化合物',
  sit_code_not_exist: '当前轮没有此座位号，请注意座位号格式例如001、002。',
  sit_code_chose: '您输入的座位号已被使用，请重新输入正确的座位号。',
  kpi_lock: 'KPI 锁定',
  kpi_confirmation: 'KPI 确认',
  global_kpi_lock: 'Global KPI 锁定',
  select_month: '请选择月份',
  need_to_wait_global_lock: '您需要等待Global锁定。',
  monthly_kpi_locked_zones: '月度KPI锁定大区',
  flavor_confirm_save:
    '未选择的风味 "{{field}}" 已经被添加到样品中。如果您确认要保存当前风味配置，相应的样品将被删除',
  temporary_admin: '临时管理员',
  unhide_sample_details: '解除隐藏样品信息',
  hide_sample: '隐藏样品',
  download_report_timeout_error_message: '访问超时，请检查网络连接。',
  download_report_success: '报告下载成功！',
  download_report_success_desc: '请在下载文件夹中查看报告。',
  download_self_evaluation_report_success: '自评报告下载成功！',
  download_report_failed: '报告下载失败。',
  download_report_failed_desc: '请稍后重试。',
  evaluation_report_add_success: '报告添加成功！',
  evaluation_report_add_success_desc: '请到“下载列表”中查看。',
  evaluation_report_add_failed: '报告添加失败。',
  evaluation_report_add_failed_desc: '请稍后重试。',
  you_can_only_select_up_to: '您最多只能选择{{field}}个，请减少选择项。',
  push_anaplan: '推送 Anaplan',
  pushed: '推送完成',
  self_evaluation_report: '点击下载自评报告',
  date_range: '日期范围',
  kpi_month_range: '月份范围',
  quick_select: '快速选择',
  current_month: '当前月份',
  current_year: '当前年份',
  a_whole_year: '今年',
  download_self_evaluation_report: '下载个人品评报告',
  select_tasters: '请选择品评员',
  create_ticket: '创建工单',
  sensory_intelligent_platform: 'Sensory 智能平台 - PBI',
  external_links: '外部链接',
  evaluation_report: '品评报告',
  download_evaluation_report: '下载品评报告',
  taster_type: '品评员类型',
  taster_evaluation_tip: '现在，您可以点击此处下载个人品评报告！',
  admin_evaluation_tip: '现在，您可以点击此处下载品评员品评报告！',
  kpi_sample: 'KPI 样品',
  add_to_download_list: '添加到下载列表',
  to_download_list: '下载列表',
  selected_tasters: '已选择的品评员',
  generation_time: '生成时间',
  start_month: '开始月份',
  end_month: '结束月份',
  download_all: '下载全部',
  physchem: '理化数据',
  physchem_disabled_tips: '样品被隐藏时无法查看理化数据',
  new_physchem_tips: '现在，你可以点击此处为样品添加理化数据',
  view_physchem_tips: '现在，你可以点击此处查看当前轮次中样品的理化数据',
  package_code: '包装编码',
  concentration_at_fu: '每风味单位浓度',
  base_beer: '基酒',
  flavor_intensities_scale: '风味程度表',
  flavor_unit: '风味单位',
  add_a_sample: '添加一个样品',
  common_kpi_quarter: '关键绩效指标季度',
  sample_duplicated_quarter_kpi_message:
    '您选择的季度、品牌和工厂已经有KPI，您将无法保存',
  select_quarter: '请选择季度',
  please_select_kpi_quarter: '请选择关键绩效指标季度',
  error_fields: '错误字段',
  your_answer: '您的答案',
  preference: '偏好',
  return: '返回',
  please_select_preference_group: '提交前请先选择您的偏好!',
  monthly_report: '月度报告',
  draft: '草稿',
  confirm_send: '确认 & 发送',
  sent_completion: '发送完成',
  send_draft: '发送草稿',
  send_draft_monthly_report: '月度报告将发送到您的邮箱。',
  please_confirm_the_recipients: '请确认月度报告的收件人',
  total_recipients: '收件人总数',
  sending: '发送中',
  sending_monthly_report_tips1: `您的邮件请求正在处理中。`,
  sending_monthly_report_tips2: `请查看“操作日志”以获取结果。`,
  configure_upgrade_center: '配置升级中心',
  sprint_content: '冲刺内容',
  release_date: '发布日期',
  add_sprint: '添加冲刺',
  sprint_meterials: '冲刺材料',
  upgrade_center: '升级中心',
  function: '功能',
  my_evaluation_report: '我的品评报告',
  upgrade_center_remove_sprint_number: '您确定要删除此冲刺编号吗',
  sprint_version_tips: '点击查看冲刺材料.',
  edit_sprint: '编辑冲刺',
  new_sprint_tips: '现在，你可以点击此处添查看的冲刺材料.',
  production_date_range: '生产日期范围',
  preparation: '准备',
  panel: '主要',
  session: '计划',
  product: '产品',
  attribute: '属性',
  common_menu_samples: '样品',
  common_menu_rounds: '轮次',
  common_menu_groups: '品评小组',
  common_menu_suspension_list: '停产管理',
  common_menu_planning_week_sessions: '下周品评计划',
  common_menu_zitec_sessions: 'ZITEC 计划',
  common_menu_brands: '常规品牌',
  common_menu_kpi_brands: 'KPI 品牌',
  common_menu_packages: '包装',
  common_menu_styles: '类型',
  common_menu_malt_variety: '麦芽品种',
  common_menu_intensities: '程度',
  common_menu_categories: '类别',
  common_menu_attributes: '风味物质属性',
  common_menu_user_management: '用户管理',
  common_menu_role_management: '角色管理',
  role_management_create: '创建自定义角色',
  role_management_current_role_prefix: '当前角色是',
  role_management_change_role: '切换角色',
  role_management_create_title: '创建自定义角色',
  role_management_role_name: '角色名称',
  role_management_permission_set: '基于以下基础设置自定义权限',
  role_management_role_name_placeholder: '请输入角色名称',
  role_management_permission_set_placeholder: '选择一个基础角色',
  role_management_search: '搜索角色',
  role_management_permission: '功能',
  role_management_view: '查看',
  role_management_edit: '编辑',
  role_management_approve: '审批',
  role_management_save_changes: '保存更改',
  role_management_reset_title: '恢复默认权限？',
  role_management_reset_tooltip: '将权限重置为[{{parentRole}}]配置。',
  role_management_reset_description: '这将把角色权限恢复为默认配置，并移除所有手动更改。此操作无法撤销。',
  role_management_reset_success: '权限重置成功！',
  role_management_reset_success_desc: '该角色的权限已重置为默认配置。您可以在下方的权限控制中查看。',
  role_management_reset_failed: '权限重置失败。',
  role_management_reset_failed_desc: '请稍后重试。',
  role_management_switch_role_title: '放弃更改？',
  role_management_switch_role_description:
    '当前存在未保存的权限更改。切换角色将放弃这些更改，是否继续？',
  role_management_switch_role_confirm: '切换角色',
  role_management_delete_title: '删除自定义角色？',
  role_management_delete_preview: '自定义角色“{{role}}”将被永久删除。该角色下的 {{count}} 位用户将被调整为“{{defaultRole}}”。确定要继续吗？',
  role_management_delete_preview_no_users: '自定义角色“{{role}}”将被永久删除。确定要继续吗？',
  role_management_delete_final: '此操作无法撤销。确定要删除此角色并清除已分配用户的角色吗？',
  role_management_load_failed: '角色加载失败。',
  role_management_permissions_failed: '权限加载失败。',
  role_management_create_required: '请输入角色名称并选择权限基准。',
  role_management_created: '自定义角色创建成功！',
  role_management_created_desc: '请在下方权限控制中查看。',
  common_apply: '应用',
  role_management_default_role: '默认角色',
  role_management_create_failed: '角色创建失败。',
  role_management_create_failed_desc: '请稍后重试。',
  role_management_create_duplicate: '该角色名称已存在！',
  role_management_create_duplicate_desc: '请输入其他角色名称后重试。',
  cancel_create_role_title: '取消创建自定义角色？',
  cancel_create_role_description: '表单中已有输入，取消后将丢失未保存内容。确定要继续吗？',
  cancel_create_role_confirm: '取消创建角色',
  role_management_saved: '角色修改保存成功。',
  role_management_save_failed: '角色修改保存失败。',
  role_management_save_success: '角色权限更新成功！',
  role_management_save_success_desc: '更改已保存，您可以在下方权限控制中查看。',
  role_management_save_failed_desc: '请稍后重试。',
  role_management_deleted: '角色删除成功。',
  role_management_delete_failed: '角色删除失败。',
  common_menu_permission_control: '权限控制',
  system: '系统',
  select_taste_type: '请选择品评类型',
  select_round: '请选择品评计划',
  a_previous_request_is_still_being_processed:
    '上一个请求仍在处理中，请稍后重试。',
  select_item: '请选择{{field}}',
  common_new_kpi_brand_button: '新建 KPI 品牌',
  common_target: '目标值',
  common_focus_brands: '焦点品牌',
  common_strategic_brands: '战略品牌',
  kpi_brands_new_page_description:
    '新增KPI品牌界面，可填写KPI品牌信息、提交和保存。',
  kpi_brands_edit_page_description:
    '编辑 KPI 品牌界面，可更新 KPI 品牌信息、提交和保存。',
  kpi_brands_edit_page_description_prefix: '查看和配置 KPI 品牌 ',
  kpi_brands_page_description: 'KPI品牌管理界面，提供查看、提交和审核功能。',
  table_apply: '应用',
  table_clear: '清除',
  table_search: '搜索',
  table_enter_to_filter: '输入以筛选...',
  table_select_to_filter: '选择以筛选...',
  table_select_all: '全选',
  table_select_all_aria: '全选所有行',
  table_select_row_aria: '选择行',
  table_filter_by: '筛选',
  table_clear_filters: '清除筛选',
  table_reset_filters: '重置筛选',
  table_no_results_for_filters: '没有找到符合筛选条件的结果。',
  table_items_selected: '项已选择',
  table_sort: '排序',
  table_sort_toggle: '点击切换排序',
  table_no_options: '无可用选项',
  table_reset: '重置',
  table_all: '全部',
  table_no_results: '未找到符合筛选条件的结果',
  common_approved_at: '审批于 {{date}}',
  common_rejected_at: '驳回于 {{date}}',
  kpi_status_created: '创建',
  kpi_status_waiting_for_approval: '等待审批',
  kpi_status_approved: '已批准',
  kpi_status_rejected: '已驳回',
  kpi_action_approve: '通过',
  kpi_action_reject: '驳回',
  common_by_user: '操作人 {{user}}',
  pagination_aria_label_next_page: '前往下一页',
  pagination_aria_label_previous_page: '前往上一页',
  pagination_aria_label_first_page: '前往第一页',
  pagination_aria_label_last_page: '前往最后一页',
  pagination_aria_label_input: '请输入要跳转的页码，范围 1 到 {totalItems}',
  pagination_aria_label_items_per_page: '每页 {pageSize} 项，点击更改',
  pagination_lines_per_page: '每页行数',
  pagination_total_pages: '共 {totalPages} 页',
  pagination_total_elements:
    '第 {firstItem}-{lastItem} 条，共 {totalItems} 条结果',
  pagination_no_results: '未找到结果',
  kpi_brand_successfully_saved: 'KPI品牌保存成功！',
  kpi_brand_saved_description:
    '请在下方KPI品牌中查看。这只是临时保存，审批提交尚未完成。',
  kpi_brand_failed_to_save: 'KPI品牌保存失败。',
  kpi_brand_save_failed_description: '请稍后重试。',
  kpi_brand_successfully_submitted: 'KPI品牌创建成功！',
  kpi_brand_submitted_description:
    '请在下方KPI品牌列表中查看。请在详情页查看审批进度；该KPI品牌需经审批后才可使用。',
  kpi_brand_failed_to_submit: 'KPI品牌创建失败。',
  kpi_brand_submit_failed_description: '请稍后重试。',
  cancel_edit_package_confirm: '取消编辑包装',
  cancel_edit_package_title: '取消编辑包装？',
  cancel_new_package_confirm: '取消新建包装',
  cancel_new_package_title: '取消新建包装？',
  content_already_exists: '内容已存在。',
  language_chinese: '中文',
  language_dutch: '荷兰语',
  language_english: '英语',
  language_french: '法语',
  language_german: '德语',
  language_italian: '意大利语',
  language_korean: '韩语',
  language_portuguese: '葡萄牙语',
  language_russian: '俄语',
  language_spanish: '西班牙语',
  language_ukrainian: '乌克兰语',
  package_name: '包装名称',
  package_successfully_created: '包装创建成功！',
  package_successfully_created_desc: '请在下方包装列表中查看。',
  package_successfully_updated: '包装更新成功！',
  package_successfully_updated_desc: '请在下方包装列表中查看。',
  packages_edit_page_description: '编辑包装信息并完成更新。',
  packages_new_page_description: '填写包装信息并完成创建。',
  packages_page_description: '集中管理所有包装类型及其配置。',
  comments_page_description: '集中管理所有风味评语属性及其配置。',
  comments_new_page_description: '填写风味评语属性信息并完成创建。',
  comments_edit_page_description: '编辑风味评语属性信息并完成更新。',
  comment_attribute_name: '风味评语属性名称',
  comment_select_category: '选择风味类别',
  actions: '行动',
  actions_page_description: '查看用户在品评会话期间创建的所有行动。',
  action_created_by: '创建人',
  my_actions: '我的行动',
  action_list_info: '行动将在本轮关闭后被创建。',
  add_taster: '添加品评员',
  alcohol_concentration_result: '酒精浓度结果',
  input_concentration: '输入浓度',
  use_breathalyzer: '使用酒精检测仪',
  enter_concentration: '输入浓度',
  result_refreshing: '结果刷新中',
  last_update: '最后更新',
  within_standard_range: '在标准范围内',
  excess_alcohol_concentration: '最大酒精浓度',
  concentration_standard: '浓度标准',
  breathalyzer_connected_successfully: '酒精检测仪连接成功！',
  breathalyzer_blow_to_capture: '请对酒精检测仪吹气以获取读数。',
  breathalyzer_connect_prompt: '点击下方按钮连接酒精检测仪。',
  absence_save_success: '请假原因添加成功！',
  absence_save_success_desc: '请在已提交的请假记录中查看。',
  submitted_absence: '已提交的请假记录',
  no_absence_to_show: '暂无请假记录',
  no_more_data: '没有更多数据',
  absence_delete_success: '请假原因删除成功！',
  absence_delete_success_desc: '请在已提交的请假记录中查看更新后的列表。',
  absence_delete_confirm_title: '删除请假记录？',
  absence_delete_confirm_description:
    '请假记录 [{{start}} - {{finish}}] 将被永久删除。确定要继续吗？',
  absence_delete_confirm_delete: '删除',
  absence_save_failed: '添加请假原因失败',
  absence_save_failed_desc: '请稍后重试。',
  absence_duplicate_date_desc: '所选日期已存在请假记录，不允许重复提交。',
  absence_delete_failed: '删除请假原因失败',
  absence_delete_failed_desc: '请稍后重试。',
};

